import React from 'react';

const IntroductionPage = () => {
    return (
        <div className="min-w-[100vw] h-full flex flex-col justify-center px-6 md:px-24">
            {/* Background Grid Pattern */}
            <div
                className="absolute inset-0 -z-10"
                style={{
                    backgroundColor: '#1A1D21',
                    backgroundImage: 'linear-gradient(var(--grid-color) 1px, transparent 1px), linear-gradient(90deg, var(--grid-color) 1px, transparent 1px)',
                    backgroundSize: '40px 40px',
                    '--grid-color': 'rgba(47, 55, 65, 1)'
                }}
            />

            {/* Content Container */}
            <div className="w-full mt-16 md:mt-0"> {/* Added margin-top for mobile to account for header */}
                <h1 className="text-2xl md:text-[54px] font-bold mb-8 md:mb-16 flex items-center gap-2">
                    ТӨСВИЙН НЭГДСЭН СИСТЕМ ГЭЖ ЮУ <span className="text-yellow-400">?</span>
                </h1>
                <div className="space-y-6 md:space-y-8 max-w-3xl">
                    <p className="text-base md:text-lg text-gray-300 leading-relaxed">
                        "Бүх шатны төрийн захиргааны байгууллагуудад зориулсан төсвийн нэгдсэн систем" бөгөөд аль ч шатны төсвийн захирагч бүх мэдээллээ нэг цонхноос харах, мэдээлэл солилцох, боловсруулах, дүн шинжилгээ хийх цогц шийдэл бүхий <span className="text-yellow-400">төсвийн
                        экосистем</span> юм.
                    </p>
                    <p className="text-base md:text-lg text-gray-300 leading-relaxed">
                        Технологийн дэвшлийг ашиглан  төрийн үйл ажиллагааг боловсронгуй, ил тод, иргэн төвтэй, хариуцлагатай, өндөр бүтээмжтэй  цахим засаглал буюу <span className="text-yellow-400">#GovTech</span>-ийг бий болгох зорилготой.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default IntroductionPage;